module.exports = __webpack_public_path__ + "img/TechInfConditioning_ua.cd55e3c7.webp";